import { useCallback, useEffect, useState } from "react";
import { IPayerBalance } from "../interface/ICurrentBalance";
import { getAccountBalanceApiRoute, postFinalisePaymentRoute } from "@api-routes";
import { getResponseToState, IPayerBalanceResponse } from "../mappers/getPaymentBalanceMapper";
import { useFetch } from "@common/hook/useFetch";
import { getLanguage } from "@utils/changeLanguage";

interface IParams {
    accountId: string;
}

export interface IFinalizeOrderResponse {
    success: boolean;
    orderNumber: string;
    paymentRef: string;
    file: {
        name: string;
        base64File: string;
    };
    prospectId: string;
}

export const usePaymentBalance = (props: IParams) => {
    const { accountId } = props;
    const [balanceDetails, setBalanceDetails] = useState<IPayerBalance>();
    const [balanceState, { get }] = useFetch();
    const [finaliseState, { post }] = useFetch();
    const lang = getLanguage();

    const getCurrentBalance = useCallback(() => {
        get<IPayerBalanceResponse>(getAccountBalanceApiRoute(accountId), {
            headers: {
                "Cache-Control": "no-cache",
            },
        }).then((payerBalanceResponse) => {
            if (payerBalanceResponse) {
                setBalanceDetails(getResponseToState(payerBalanceResponse));
            }
        });
    }, [get, accountId]);

    const finaliseBalancePayment = (
        orderId: string,
        finalisePaymentCallback: (data: IFinalizeOrderResponse) => void
    ) => {
        post<IFinalizeOrderResponse>(postFinalisePaymentRoute(lang), {
            body: {
                orderId: orderId,
            },
        }).then((response) => {
            if (response) {
                finalisePaymentCallback(response);
            }
        });
    };

    useEffect(getCurrentBalance, [getCurrentBalance]);

    return { balanceDetails, balanceState, getCurrentBalance, finaliseState, finaliseBalancePayment };
};
